import { compose, branch } from 'recompose'

import wrapField from '../shared/wrapField'
import withRemoteOptions from './wrappers/remoteOptionsHOC'
import withRemoteSearch from './wrappers/remoteSearchHOC'

export const wrapSelect = WrappedComponent => {
	return(
		compose(
			wrapField,
			branch(
				({ remoteOptions }) => remoteOptions,
				withRemoteOptions
			),
			branch(
				({ isSearchable, remoteOptions }) => isSearchable && remoteOptions,
				withRemoteSearch
			)
		)(WrappedComponent)
	)
}

export default wrapSelect
